// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-183db203]{text-transform:none!important}.transparencyClipPath[data-v-183db203]{clip-path:url(#myClip)}canvas[data-v-183db203]{border:none;display:block;float:left;pointer-events:none}.camera_image[data-v-183db203]{left:0;position:absolute;top:0;width:100%}.slider_label[data-v-183db203]{background-color:#1976d2;bottom:-28px;position:absolute;text-align:center;width:100px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
